export const fieldMappingsVariables = (
  sessionId: string,
  editingFinished: boolean,
) => (editingFinished ? { sessionId, includeFinished: true } : { sessionId });

export const isFinishedEditUrl = (searchParams: URLSearchParams) =>
  searchParams.get("edit") === "1";
